<template>
  <div id="promotion">
    <div class="body_center">
      <div class="body_center_first">
        <div class="first_title">邦人营销推广</div>
        <div class="first_msg">用户连接用户，在当下与未来构建新型信任关系</div>
      </div>
      <div class="body_center_hr">
        <div class="hr_div"></div>
      </div>
      <div class="body_center_second">
        <div class="second_title">品牌营销</div>
        <div class="second_msg">多维触达<br />连接广大用户群体，赢得用户关注和好感</div>
      </div>
      <div class="body_center_hr">
        <div class="hr_div"></div>
      </div>
      <div class="body_center_third">
        <div class="third_title">内容营销</div>
        <div class="third_msg">深度转化<br />通过内容合作广泛发酵，帮助品牌建立内容传播链路</div>
      </div>
      <div class="body_center_hr">
        <div class="hr_div"></div>
      </div>
      <div class="body_center_fourth">
        <div class="fourth_title">达人推广</div>
        <div class="fourth_msg">沟通心智<br />通过IP作者合作推广，帮助品牌建立内容传播链路</div>
      </div>
      <div class="body_center_fifth">
        <div class="body_center_fifth_top">选择邦人营销的理由</div>
        <div class="body_center_fifth_list">
          <div class="body_center_fifth_list_item">
            <div class="body_center_fifth_list_item_title">多元用户</div>
            <div class="body_center_fifth_list_item_msg">覆盖内容广泛<br />多元化的阅读行为背后是丰富的用户<br />群体</div>
          </div>
          <div class="body_center_fifth_list_item">
            <div class="body_center_fifth_list_item_title">服务体系</div>
            <div class="body_center_fifth_list_item_msg">多场景的数字营销<br />全营销链路服务能力打造全面专业的一<br />站式服务支持</div>
          </div>
          <div class="body_center_fifth_list_item">
            <div class="body_center_fifth_list_item_title">精准高效</div>
            <div class="body_center_fifth_list_item_msg">深度的广告追踪<br />微博独特的开放型社交生态，效果可<br />评估追踪并可后续建立深度联系</div>
          </div>
        </div>
      </div>
      <div class="body_center_sixth">
        <div class="body_center_sixth_title">请留下您的联系方式，专属顾问会尽快与您联系</div>
        <div class="body_center_sixth_cont">
          <div class="body_center_sixth_cont_left">
            <div class="body_center_sixth_cont_left_list">
              <div class="li">
                <div class="body_center_sixth_cont_left_list_item"><input placeholder="公司名称" /></div>
                <div class="body_center_sixth_cont_left_list_item"><input placeholder="姓名" /></div>
              </div>
              <div class="li">
                <div class="body_center_sixth_cont_left_list_item"><input placeholder="手机号码" /></div>
                <div class="body_center_sixth_cont_left_list_item"><input placeholder="E-mail" /></div>
              </div>
            </div>
          </div>
          <div class="body_center_sixth_cont_right">
            <div>或者直接拨打</div>
            <div>0123-456-7899</div>
            <div>9:00~18:00 (周一到周五)</div>
          </div>
          <div class="body_center_sixth_cont_btn">提交信息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
      }
    },
    created () {
    },
    methods: {
    }
  }
</script>
<style src="@/pages/index/promotion/index.css" scoped>

</style>
